module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "grey",
    attrs: {
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.exit($event)
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")])], 1)], 1), _vm._v(" "), (_vm.loading !== true) ? _c('v-card-text', [_vm._l((_vm.customer.customer), function(report) {
    return _c('tr', [_vm._v("\n            " + _vm._s(report.timestamp) + " " + _vm._s(report.message) + "\n          ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.loading !== true) ? _c('v-card-text', [_vm._v("\n\n        " + _vm._s(_vm.link) + " "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "color": "#1976d2"
    },
    on: {
      "click": function($event) {
        _vm.copyUrl(_vm.link)
      }
    }
  }, [_vm._v("Скопировать ссылку на профиль")])]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/vue-loader/lib/template-compiler?{"id":"data-v-56aeda59","hasScoped":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BlackForm.vue
// module id = 417
// module chunks = 0